export default __webpack_public_path__ + "static/media/Picture.5d6f8757.jpg";